module.exports = __webpack_public_path__ + "static/andy-farley-5decf367ae0385726003e9d086744581.png";